function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export var statusActions;

(function (statusActions) {
  statusActions["ok"] = "ok";
  statusActions["error"] = "error";
})(statusActions || (statusActions = {}));

export var listUserSubdata = ["beneficiario", "contratante", "asegurado"];
export var listPolizaSubData = ["beneficiario", "contratante", "asegurado", "payment_information", "broker_information", "document_actions", "assist_card_actions", "poliza_endorsement"];
export var createPoliza = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(poliza, token) {
    var formData, response, polizaResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            formData = buildPolizaFormData(poliza);
            _context.next = 4;
            return fetch("/api/v1/polizas", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            polizaResponse = _context.sent;
            return _context.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", {
              status: statusActions.error
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function createPoliza(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var updatePoliza = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(poliza, token) {
    var formData, response, polizaResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            formData = buildPolizaFormData(poliza);
            _context2.next = 4;
            return fetch("/api/v1/polizas/".concat(poliza.id), {
              method: "PATCH",
              headers: {
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();

          case 7:
            polizaResponse = _context2.sent;

            if (!(response.status === 200)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 12:
            return _context2.abrupt("return", {
              status: statusActions.error,
              payload: polizaResponse
            });

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            return _context2.abrupt("return", {
              status: statusActions.error
            });

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 15]]);
  }));

  return function updatePoliza(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var createPolizaEndorsement = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(poliza, token) {
    var formData, response, polizaResponse;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            formData = buildPolizaFormData(poliza);
            formData.append("poliza_endorsement[poliza_id]", poliza.id);
            _context3.next = 5;
            return fetch("/api/v1/poliza_endorsements", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 5:
            response = _context3.sent;
            _context3.next = 8;
            return response.json();

          case 8:
            polizaResponse = _context3.sent;
            return _context3.abrupt("return", {
              status: statusActions.ok,
              payload: polizaResponse
            });

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            return _context3.abrupt("return", {
              status: statusActions.error
            });

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  }));

  return function createPolizaEndorsement(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
export var sendDispatchEmail = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(polizaId, groupCheckbox, token) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetch("/api/v1/polizas/".concat(polizaId, "/send_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              },
              body: JSON.stringify({
                group_checkbox: groupCheckbox
              })
            });

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return response.json();

          case 6:
            responseJson = _context4.sent;
            return _context4.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0);
            return _context4.abrupt("return", {
              status: statusActions.error
            });

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }));

  return function sendDispatchEmail(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
export var sendExpirationEmail = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(polizaId, token) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetch("/api/v1/polizas/".concat(polizaId, "/send_expiration_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context5.sent;
            _context5.next = 6;
            return response.json();

          case 6:
            responseJson = _context5.sent;
            return _context5.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
            return _context5.abrupt("return", {
              sstatus: statusActions.error
            });

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));

  return function sendExpirationEmail(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();
export var sendChargeEmail = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(token, poliza_payment_id) {
    var response, responseJson;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetch("/api/v1/poliza_payment/".concat(poliza_payment_id, "/send_charge_email"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context6.sent;
            _context6.next = 6;
            return response.json();

          case 6:
            responseJson = _context6.sent;
            return _context6.abrupt("return", {
              status: statusActions.ok,
              payload: responseJson
            });

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error(_context6.t0);
            return _context6.abrupt("return", {
              status: statusActions.error
            });

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }));

  return function sendChargeEmail(_x12, _x13) {
    return _ref6.apply(this, arguments);
  };
}();

var buildPolizaFormData = function buildPolizaFormData(poliza) {
  var formData = new FormData(); // buildFormatDataFromJson(formData, poliza, "poliza");

  for (var key in poliza) {
    if (listPolizaSubData.includes(key)) {
      buildPolizaSubData(formData, poliza[key], key);
    } else if (key === "item_asegurados") {
      buildItemAseguradoFormData(formData, poliza.item_asegurados);
    } else if (key === "additional_files") {
      buildAdditionalFilesFormData(formData, poliza.additional_files);
    } else if (key === "additional_files_actions") {
      buildAdditionalFilsActionsFormData(formData, poliza.additional_files_actions);
    } else if (poliza[key] !== undefined && poliza[key] !== null) {
      formData.append("poliza[".concat(key, "]"), poliza[key]);
    }
  }

  return formData;
};

var buildPolizaSubData = function buildPolizaSubData(formData, subForm, key) {
  for (var subKey in subForm) {
    if (["emails", "addresses"].includes(subKey)) {
      buildSubFormData(formData, subForm, key, subKey);
    } else if (subForm[subKey] !== undefined && subForm[subKey] !== null) formData.append("poliza[".concat(key, "][").concat(subKey, "]"), subForm[subKey]);
  }

  return formData;
};

var buildItemAseguradoFormData = function buildItemAseguradoFormData(formData, itemAsegurado) {
  itemAsegurado.forEach(function (item, index) {
    Object.entries(item).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      if (value !== null && value !== undefined) {
        formData.append("poliza[item_asegurados][".concat(index, "][").concat(key, "]"), value);
      }
    });
  });
};

var buildSubFormData = function buildSubFormData(formData, subForm, key, sub_key) {
  for (var i = 0; i < subForm[sub_key].length; i++) {
    for (var email_sub_key in subForm[sub_key][i]) {
      if (subForm[sub_key][i][email_sub_key] !== undefined && subForm[sub_key][i][email_sub_key] !== null) {
        formData.append("poliza[".concat(key, "][").concat(sub_key, "][][").concat(email_sub_key, "]"), subForm[sub_key][i][email_sub_key]);
      }
    }
  }
};

var buildAdditionalFilesFormData = function buildAdditionalFilesFormData(formData, fileList) {
  for (var fileKey in fileList) {
    if (fileList[fileKey]) formData.append("poliza[additional_files][]", fileList[fileKey]);
  }

  return formData;
};

var buildAdditionalFilsActionsFormData = function buildAdditionalFilsActionsFormData(formData, filesActions) {
  filesActions.forEach(function (fileAction) {
    for (var key in fileAction) {
      formData.append("poliza[additional_files_actions][][".concat(key, "]"), fileAction[key]);
    }
  });
};